import React, {useEffect, useState, useRef} from "react";
import "./DiscoverPlaces.scss";
import {useItems} from "../../hooks/useItems";
import Image2 from "../../Images/image2.png";
import downarrow from '../../Images/downarrow.png'
import rightarrow from '../../Images/chevron.png'
import { Container } from "react-bootstrap";


let httpProtocol = process.env.REACT_APP_HTTPPROTOCOL;
let fronturl = process.env.REACT_APP_FRONTURL;


const DiscoverPlaces = ({searchQueryData}) => {
  // console.log("searchQueryData====>>>", searchQueryData);
  let backendUrl = process.env.REACT_APP_BACKEND_API;
  // const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState(searchQueryData || '');
  const divRef = useRef(null);
  // useEffect(() => {
  //   divRef.current.scrollIntoView({ bottom:0, behavior: 'smooth' });
  // });
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useItems(searchQuery);

  useEffect(()=>{
    setSearchQuery(searchQueryData);
  },[searchQueryData]);

  const handleErrorImage = (event) => {
    event.target.src = Image2;
  };
  useEffect(() => {
    if (window !== undefined) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <Container>
      <div className="image_section_main_wrapper">
        <div className="image_section_upper_wrapper">
          <div className="first_wrapper">
          Discover <span> Dining Delights</span>
          </div>
          <div className="third_wrapper">
          From North to South Indian, from Korean to Italian, explore a variety of cuisines and enjoy a seamless dining experience.</div>
        </div>
        <div className="image_section_middle_wrapper">
          {!!data && data != undefined && 
            <>
              {data?.pages?.map((page) =>{
                  let itemsData = page ? page?.data?.data:[];
                  {/* {console.log("itemdata===>",itemsData)} */}
                  if(itemsData.length>0){
                    return (
                      itemsData.map((item, index) => {
                        let contactInfoData = (item?.contactInfos?.content != undefined)?JSON.parse(item?.contactInfos?.content):"";
                        let linkBusiness = (item?.slug_subdomain != null) ? httpProtocol + item?.slug_subdomain : (item?.slug != null) ? fronturl + item?.slug: "/";
                        if (contactInfoData.length > 0) {
                          contactInfoData = JSON.parse(contactInfoData);
                        }
                        return (
                          <div className="image_section_image_wrapper">
                          <a href={linkBusiness}  target='_blank' key={item?.id+index} style={{minHeight:"415px", maxHeight:"415px"}}>
                            <img style={{maxHeight:"200px"}} src={backendUrl + 'uploads/'+ item?.banner} onError={handleErrorImage}/>
                            <div className="overlay">
                              <div className="overlay_inside_wrapper">
                                <div className="text">{item?.title}</div>
                                <div className="icon"><img src={rightarrow}/></div>
                              </div>
                              <div className="imagesection_text_value">
                                {contactInfoData?.contactInfoAddress}
                              </div>
                            </div>
                          </a>
                          </div>
                        );
                      })
                    )
                  }else{
                    return <p>No restaurants available</p>;
                  }
                }
              )}
            </>
          }
        </div>
        {
          hasNextPage &&
            <div className="loadmoremain">
              <div className="">
                <button
                  className="redbutton"
                  onClick={() => fetchNextPage()}
                  disabled={!hasNextPage || isFetchingNextPage}  
                >                    
                  {isFetchingNextPage ? 'Loading more...' : hasNextPage ? 'View more' : ''}
                </button>
              </div>          
            </div>
        }
        <div className="downarrow">
          <div className="downinner">
            <img src={downarrow} ref={divRef}  />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DiscoverPlaces;
